import { StackIcon } from 'components/StackIcon/StackIcon'
import cls from './WorksPage.module.scss'
import firebase from 'shared/assets/icons/firebase-icon.jpg'
import framer from 'shared/assets/icons/framer-motion-icon.png'
import react from 'shared/assets/icons/react-icon.webp'
import spring from 'shared/assets/icons/react-spring-icon.png'
import redux from 'shared/assets/icons/redux-icon.png'
import github from 'shared/assets/icons/github-logo.png'
import { useEffect, useState } from 'react'

export const WorksPage = () => {
    const [data, setData] = useState([])

    const getGithub = async () => {
        const response = await fetch('https://api.github.com/users/matvey770/repos')
        const data = await response.json()
        setData(data)
    }

    useEffect(() => {
        getGithub()
    }, [])

    const redirectToRepo = (url: string) => {
        window.open(url)
    }

    return (
        <div className={cls.worksPage}>
            <div className={cls.container}>
                <div onClick={() => redirectToRepo("https://taglife.net/")} className={cls.item}>
                    <div className={cls.textWrapper}>
                        <div className={cls.itemName}>TagLife PWA App</div>
                        <div className={cls.text}>
                            <ul>
                                <li>React PWA приложение для людей с низкой самооценкой</li>
                                <li>В качестве базы данных использован Google Firebase</li>
                                <li>Возможность установки как полноценного приложения</li>
                                <li>Анонимная аутентификация, push-уведомления</li>
                                <li>Система жестов (like tinder свайпы) для просмотра достижений</li>
                            </ul>
                        </div>
                        <div className={cls.stack}>
                            <div className={cls.itemName}>Стэк технологий</div>
                            <div className={cls.stackWrapper}>
                                <StackIcon icon={react} />
                                <StackIcon className={cls.iconMargin} icon={firebase} />
                                <StackIcon className={cls.iconMargin} icon={redux} />
                                <StackIcon className={cls.iconMargin} icon={spring} />
                                <StackIcon className={cls.iconMargin} icon={framer} />
                            </div>
                        </div>
                    </div>
                    <div className={cls.itemImage}>
                        <img src="images/taglife.jpg" alt="img" className={cls.image}></img>
                    </div>
                </div>
                <div onClick={() => redirectToRepo("https://github.com/matvey770/feature")} className={cls.item}>
                    <div className={cls.textWrapper}>
                        <div className={cls.itemName}>Feature App</div>
                        <div className={cls.text}>
                            <ul>
                                <li>Интернет-магазин одежды</li>
                                <li>В качестве библиотеки форм используется formik</li>
                            </ul>
                        </div>
                        <div className={cls.stack}>
                            <div className={cls.itemName}>Стэк технологий</div>
                            <div className={cls.stackWrapper}>
                                <StackIcon icon={react} />
                                <StackIcon className={cls.iconMargin} icon={redux} />
                            </div>
                        </div>
                    </div>
                    <div className={cls.itemImage}>
                        <img src="images/feature.jpg" alt="img" className={cls.image}></img>
                    </div>
                </div>
            </div>
            <div className={cls.gitTitle}>Github репозитории</div>
            <div className={cls.gitContainer}>
                {data.map((item: any) => {
                    return (
                        <div onClick={() => redirectToRepo(item.html_url)} className={cls.gitItem} key={item.name}>
                            <div className={cls.gitName}>{item.name}</div>
                            {/* <div>{item.html_url}</div> */}
                            <img className={cls.gitLogo} src={github} alt="git"></img>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}